import { DevotionalContent } from "@/components/DevotionalContent";
import { PreviousDevotionals } from "@/components/PreviousDevotionals";
import { SubscriptionForm } from "@/components/SubscriptionForm";
import { useAuth } from "@/contexts/AuthContext";
import { getDevotionalForDate, getPreviousDevotionals } from "@/data/devotionals";
import { useQuery } from "@tanstack/react-query";
import { format, isBefore, parseISO } from "date-fns";


const Index = () => {
  const { user } = useAuth();
  const today = new Date();
  const startDate = parseISO("2025-01-01");
  
  // If today or tomorrow, show Jan 1st 2025. Otherwise, show the current day's devotional
  const targetDate = isBefore(today, startDate) ? startDate : today;

  const { data: devotionalData, isLoading: isLoadingDevotional } = useQuery({
    queryKey: ["devotional", format(targetDate, "yyyy-MM-dd")],
    queryFn: async () => {
      const data = await getDevotionalForDate(targetDate);
      return data;
    },
    // Refetch at midnight
    refetchOnWindowFocus: true,
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  });

  const { data: previousDevotionals = [], isLoading: isLoadingPrevious } = useQuery({
    queryKey: ["previousDevotionals", format(targetDate, "yyyy-MM-dd")],
    queryFn: () => getPreviousDevotionals(targetDate, 3), // Explicitly request 3 days
  });

  if (isLoadingDevotional || isLoadingPrevious) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-sage-50 to-white flex items-center justify-center">
        <p className="text-xl text-sage-600">Loading devotional...</p>
      </div>
    );
  }

  if (!devotionalData) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-sage-50 to-white flex items-center justify-center">
        <p className="text-xl text-sage-800">No devotional available for today.</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-sage-50 to-white">
      <main className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-3">
            <DevotionalContent {...devotionalData} userId={user?.id} />
          </div>
          <div className="lg:col-span-1 space-y-8">
            <div className="bg-white rounded-lg shadow-sm p-6 border border-sage-100">
              <h3 className="text-xl font-serif font-semibold text-sage-800 mb-4">
                Never Miss a Devotional
              </h3>
              <p className="text-sage-600 mb-6">
                Subscribe to receive daily devotionals directly in your inbox or via WhatsApp.
              </p>
              <SubscriptionForm />
            </div>
            <PreviousDevotionals devotionals={previousDevotionals} />
          </div>
        </div>
      </main>

      <footer className="bg-sage-50 mt-16">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <p className="text-center text-lg text-sage-600">
            © {new Date().getFullYear()} Husband & Wife Devotional. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default Index;